var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "root",
    staticClass: "root"
  }, [_c('chat-messages', {
    attrs: {
      "room": _vm.currentRoom,
      "senderId": _vm.senderId,
      "senderName": _vm.senderName,
      "isAfterBusinessHour": _vm.result.res === _vm.AFTER_BUSINESS_HOURS,
      "senderType": "user",
      "sessionToken": _vm.currentUser ? _vm.currentUser.accessToken : null,
      "messageLoading": _vm.messageLoading,
      "displayVisibilityState": _vm.displayVisibilityState
    },
    on: {
      "view-new-chat": _vm.viewNewChat,
      "enter-room": _vm.onEnterRoom,
      "fetch-new-messages": _vm.onFetchNewMessages,
      "update-messages": _vm.onUpdateMessages,
      "set-product-code": _vm.setProductCode,
      "set-message-loading": _vm.setMessageLoading,
      "chat-is-closed": _vm.onChatClosed,
      "reload-system-state": _vm.reloadSystemState,
      "read-sinceId-clear": _vm.readSinceIdClear,
      "create-notice-timer": _vm.createNoticeTimer,
      "start-polling": _vm.startPolling,
      "stop-polling": _vm.stopPolling,
      "set-business-hours": _vm.exeApiGetBusinessHours
    }
  }), _c('v-card', {
    ref: "input",
    staticClass: "chat-input"
  }, [_c('v-card-actions'), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(_vm.result.res === _vm.AFTER_BUSINESS_HOURS) ? _c('v-flex', {
    staticClass: "businessHour",
    attrs: {
      "lg10": "",
      "xs12": ""
    }
  }, [_c('p', [_vm._v("ただいまの時間はオペレーター受付時間外です。")]), _vm._v(" "), _c('p', [_vm._v("（オペレーター受付時間" + _vm._s(_vm.businessHourStart) + "~" + _vm._s(_vm.businessHourEnd) + "）")])]) : _vm._e(), _vm._v(" "), (!_vm.isBotMode() && _vm.result.res !== _vm.AFTER_BUSINESS_HOURS && _vm.op_seated_result === _vm.NOT_SEATED) ? _c('v-flex', {
    staticClass: "operatorNotSeated",
    attrs: {
      "lg10": "",
      "xs12": ""
    }
  }, [_c('p', [_vm._v("ただいま大変込み合っております。")]), _vm._v(" "), _c('p', [_vm._v("ご案内可能になり次第、お繋ぎいたしますのでもう少々お待ちください。")])]) : _vm._e(), _vm._v(" "), (_vm.$options.chatClient && _vm.isClosed) ? _c('v-flex', {
    staticClass: "chatClosed",
    attrs: {
      "lg10": "",
      "xs12": ""
    }
  }, [_c('p', [_vm._v("このチャットは終了しました。")])]) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg10": "",
      "xs12": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputText),
      expression: "inputText"
    }],
    ref: "inputText",
    attrs: {
      "placeholder": "入力",
      "rows": "3",
      "disabled": !_vm.isTextAreaActive() || !_vm.freetextAvailable || _vm.isClosed
    },
    domProps: {
      "value": (_vm.inputText)
    },
    on: {
      "focus": _vm.focusUserInputCheck,
      "blur": _vm.blurUserInputCheck,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "send_btn",
    attrs: {
      "light": "light",
      "disabled": !_vm.isFormSubmittable() || !_vm.freetextAvailable
    },
    on: {
      "click": _vm.sendText
    }
  }, [_vm._v("送信")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "amber",
    attrs: {
      "icon": "icon",
      "dark": "dark",
      "disabled": _vm.isFileSendButtonDisabled() || !_vm.freetextAvailable
    },
    on: {
      "click": _vm.onClickOpenFolder
    }
  }, [_c('v-icon', [_vm._v("folder_open")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(this.entering === _vm.ENTERING) ? _c('v-flex', {
    attrs: {
      "lg10": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "entering"
  }, [_vm._v("オペレーター入力中・・・")])]) : _vm._e()], 1), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "capture": "camera",
      "disabled": !_vm.freetextAvailable
    },
    on: {
      "change": _vm.onChangeFile
    }
  })], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f515c8e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chat.vue
// module id = TfK7
// module chunks = 1